import React, { useMemo } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Drawer } from 'rsuite';
import { useTranslation } from 'react-i18next';
import useAuth from '../../../../../hooks/useAuth';
import CPIDataGridFiche from '../../../../../components/DataGrid/CPIDataGridFiche';

function ChatList({
  listOpen, closed, entity, scope,
}) {
  const { change_perimetre } = useAuth();
  const handleChange = (entity_id, scope_id) => {
    change_perimetre(entity_id, scope_id);
  };

  const { t } = useTranslation();
  const filterValue = [
    {
      name: 'code',
      operator: 'contains',
      type: 'string',
      value: ''      
    },
    {
      name: 'name',
      operator: 'contains',
      type: 'string',
      value: ''
    },
  ];
  const columns = useMemo(() => [
    {
      name: 'code',
      header:t('composant.modal_select_filiale.code'),
      minWidth: 150,
      defaultFlex: 1,
      render: ({ data, value }) => (
        <Link to="/dashboard" onClick ={() => handleChange(data.id, scope.id)} style={{color:'Black', fontSize:'12px', textDecoration: 'none'}}>
          {value}
      </Link>
      ),
    },
    {
      name: 'name',
      header: t('composant.modal_select_filiale.nom'),
      minWidth: 100,
      defaultFlex: 1,
    }
  ], [t]);

  const columnsScope = useMemo(() => [
    {
      name: 'code',
      header:t('composant.modal_select_filiale.code'),
      minWidth: 150,
      defaultFlex: 1,
      render: ({ data, value }) => (
        <Link to="/dashboard" onClick ={() => handleChange(entity.id, data.id)} style={{color:'Black', fontSize:'12px', textDecoration: 'none'}}>
          {value}
      </Link>
      ),
    },
    {
      name: 'name',
      header: t('composant.modal_select_filiale.nom'),
      minWidth: 100,
      defaultFlex: 1,
    },
  ], [t]);

  const cardBody = (
    
      <Tabs variant="pills" style={{ paddingBottom: '0px !imprtant' }}>
        <Tab
          eventKey="details"
          title={t('entity')}
          style={{ height: 'calc(100vh - 200px)' }}
        >
          <CPIDataGridFiche
            idProperty="id"
            emptyText={t('NoData')}
            columns={columns}
            dataSource={entity}
            pagination={false}
            defaultFilterValue={filterValue}
          />
        </Tab>
        {scope && scope?.length !== 0 && (
          <Tab
            eventKey="treasury"
            title={t('scope')}
            style={{ height: 'calc(100vh - 200px)' }}
          >
            <CPIDataGridFiche
              idProperty="id"
              emptyText={t('NoData')}
              columns={columnsScope}
              dataSource={scope}
              pagination={false}
              defaultFilterValue={filterValue}
            />
          </Tab>
        )}
      </Tabs>
  );

  return (
    <Drawer size='sm' placement='right' open={listOpen} onClose={closed}>
      <Drawer.Header>
        <Drawer.Title>{t('titleChange')}</Drawer.Title>
      </Drawer.Header>
      {cardBody}
    </Drawer>
  );
};

export default ChatList;
